<template>
    <div class="activity">
        <div class="activity-header">
            <img :src="cover_image" alt="爱驿站">
        </div>

        <div class="activity-body">
            <div class="main">
                <div class="main-title">{{title}}</div>

                <div class="main-price"> <span>男士{{male_pay}}元</span> <span style="margin-left: 30px">女士{{female_pay}}元</span> </div>

                <div class="main-people">
                    <div class="people-list">
                        <img src="/activity/nan.png" alt="爱驿站">
                        <span style="margin-left: 10px">限{{male_max_count}}人</span>
                        <span style="margin-left: 15px">已报{{male_sign_up}}人</span>
                    </div>
                    <div class="people-list" style="margin-left: 20px">
                        <img src="/activity/nv.png" alt="爱驿站">
                        <span style="margin-left: 10px">限{{female_max_count}}人</span>
                        <span style="margin-left: 15px">已报{{female_sign_up}}人</span>
                    </div>
                </div>

                <div class="main-timeout">
                    <img src="/activity/timeout.png" alt="爱驿站">
                    <span style="margin-left: 10px">报名倒计时</span>
                    <span style="margin-left: 20px;margin-top: -2px">
                        <van-count-down :time="timeout">
                              <template #default="timeData">
                                <span class="block">{{ timeData.days }}</span>
                                <span class="block">天</span>
                                <span class="block">{{ timeData.hours }}</span>
                                <span class="block">小时</span>
                                <span class="block">{{ timeData.minutes }}</span>
                                <span class="block">分</span>
                                <span class="block">{{ timeData.seconds }}</span>
                                <span class="block">秒</span>
                              </template>
                        </van-count-down>
                    </span>
                </div>
            </div>
        </div>

        <div class="activity-option">
            <div class="main">
                <div class="option-title">活动信息</div>
                <div class="main-timeout">
                    <img src="/activity/time.png" alt="爱驿站">
                    <span class="title">时间</span>
                    <span class="text">{{time_format}}</span>
                </div>

                <div class="main-timeout">
                    <img src="/activity/location.png" alt="爱驿站">
                    <span class="title">地点</span>
                    <span class="text">{{address}}</span>
                </div>

                <div class="main-timeout">
                    <img src="/activity/flag.png" alt="爱驿站">
                    <span class="title">发起</span>
                    <span class="text">{{station_title}}</span>
                </div>

                <div class="main-timeout">
                    <img src="/activity/option.png" alt="爱驿站">
                    <span class="title">条件</span>
                    <span class="text">{{condition}}</span>
                </div>
            </div>
        </div>


        <div class="activity-detail">
            <div class="main">
                <div class="detail-title">活动介绍</div>

                <div class="detail-img" >
                    <img v-for="(item, index) in introduction" :key="index" :src="item" alt="爱驿站">
                </div>
            </div>
        </div>


<!--        <div class="footer" @click="goDownLoad">-->
        <div class="footer">
            <div class="footer-img">
                <img src="/ayz_icon/logo.webp" alt="爱驿站">
            </div>
            <div class="footer-text">
                <div>手机应用商店下载爱驿站APP</div>
                <div>查看更多真实、优质会员资料</div>
            </div>
        </div>
    </div>
</template>
<script>
import ayzAjax from "@/plugins/axios";
import {showFailToast} from "vant";

export default {
    name: "ActivityView",
    data: function () {
        return {
            id:null,
            title:'',
            cover_image:'',
            timeout:0,
            male_pay:0,
            female_pay:0,
            male_max_count:0,
            female_max_count:0,
            male_sign_up:0,
            female_sign_up:0,
            address:'',
            station_title:'',
            condition:'',
            time_format:'',
            introduction:[],
        }
    },
    created() {
        this.id = this.$route.params.act_id;
        this.getActivity();
    },
    methods: {
        getActivity() {
            try {
                ayzAjax.get('/get_activity?activity_id=' + this.id).then((response) => {
                    if(response.data.code !== 200){
                        showFailToast(response.data.msg);
                        return false;
                    }
                    this.cover_image = response.data.data.activity.cover_image;
                    this.title = response.data.data.activity.title;
                    this.timeout = response.data.data.activity.timeout * 1000;
                    this.time_format = response.data.data.activity.time_format;
                    this.station_title = response.data.data.activity.station_title;
                    this.condition = response.data.data.activity.condition_format;
                    this.female_sign_up = response.data.data.activity.female_sign_up;
                    this.male_sign_up = response.data.data.activity.male_sign_up;
                    this.female_max_count = response.data.data.activity.female_max_count;
                    this.male_max_count = response.data.data.activity.male_max_count;
                    this.female_pay = response.data.data.activity.female_pay;
                    this.male_pay = response.data.data.activity.male_pay;
                    this.address = response.data.data.activity.address;
                    this.introduction = response.data.data.activity.introduction;
                    console.log(this.introduction);
                })
            }catch(err) {
                console.log(err);
                showFailToast('网络错误,请稍后再试')
            }
        },
        goDownLoad(){
            this.$router.push({ path: '/download' });
        },
    }
}
</script>

<style scoped lang="scss" >
.activity{
    background: #F6F6F6;
    text-align: left;
    .activity-header{
        width: 100%;
        height: 150px;
        background: #222222;
        img{
            width: 100%;
            height: 180px;
        }
    }
    .activity-body{
        display: flex;
        padding-left: 10px;
        padding-right: 10px;
        .main{
            padding-left: 20px;
            padding-right: 20px;
            padding-bottom: 20px;
            width: 100%;
            min-height: 150px;
            background: #fff;
            border-radius: 15px;
            .main-title{
                padding-top: 20px;
                font-size: 16px;
                color: #111111;
                font-weight: 550;
            }
            .main-price{
                font-weight: bold;
                margin-top: 20px;
                font-size: 13px;
                color: #222222;
            }
            .main-people{
                display: flex;
                margin-top: 15px;
                background: #F6F6F6;
                padding: 5px 10px 5px 10px;
                border-radius: 5px;
                color: #777777;
                font-size: 10px;
                line-height: 20px;
                .people-list{
                    display: flex;
                    img{
                        width: 18px;
                        height: 18px;
                    }
                }
            }
            .main-timeout{
                display: flex;
                margin-top: 15px;
                background: #F6F6F6;
                border-radius: 5px;
                color: #777777;
                font-size: 10px;
                line-height: 20px;
                padding: 5px 10px 5px 10px;
                img{
                    width: 18px;
                    height: 18px;
                }
            }
        }
    }
    .activity-option{
        margin-top: 10px;
        display: flex;
        padding-left: 10px;
        padding-right: 10px;
        .main {
            padding-left: 20px;
            padding-right: 20px;
            padding-bottom: 20px;
            width: 100%;
            min-height: 150px;
            background: #fff;
            border-radius: 15px;
            .option-title{
                padding-top: 20px;
                font-size: 15px;
                color: #222222;
                font-weight: bold;
            }
            .main-timeout{
                display: flex;
                margin-top: 10px;
                //background: #F6F6F6;
                border-radius: 5px;
                //color: #777777;
                font-size: 12px;
                line-height: 20px;
                padding: 5px 10px 0 0;
                img{
                    width: 15px;
                    height: 15px;
                    margin-top: 2px;
                }
                .title{
                    color: #222222;
                    font-size: 12px;
                    font-weight: bold;
                    margin-left: 10px;
                    display: inline-block;
                    width: 40px;
                }
                .text{
                    color: #646464;
                    font-size: 12px;
                    width: 200px;
                }
            }
        }
    }
    .activity-detail{
        margin-top: 10px;
        display: flex;
        padding-left: 10px;
        padding-right: 10px;
        .main {
            padding-left: 10px;
            padding-right: 10px;
            padding-bottom: 10px;
            width: 100%;
            min-height: 150px;
            background: #fff;
            border-radius: 15px;
            .detail-title{
                padding-top: 20px;
                font-size: 15px;
                color: #222222;
                font-weight: bold;
            }
            .detail-img{
                //height: 150px;
                margin-top: 15px;
                //background: #111111;
                border-radius: 15px;
                overflow: hidden;
                padding: 0;

                img{
                    width: 100%;
                    height: auto;
                    outline-width:0;
                    vertical-align:top;
                }
            }
        }
    }
    .block{
        color: #777777;
        font-size: 10px;
        line-height: 20px;
    }
    .footer{
        display: flex;
        margin: 10px;
        //margin-bottom: 10px;
        padding-top: 20px;
        padding-bottom: 20px;
        //width: 100%;
        min-height: 66px;
        background: #fff;
        border-radius: 20px;
        text-align: left;

        .footer-img{
            margin-left: 20px;
            width: 66px;
            height: 66px;
            img{
                width: 66px;
                height: 66px;
            }
        }
        .footer-text{
            font-weight: 400;
            font-size: 13px;
            color: #777777;
            margin-left: 20px;
            //line-height: 15px;
            div{
                margin-top: 10px;
            }
        }
    }
}

</style>